import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import React from 'react';
import PropTypes from 'prop-types';
import { ListHeader, Tabs, Tab, CurrentReportTab, AllPastReportsTab, useUser } from 'components';
import { jsx as ___EmotionJSX } from "@emotion/react";

var PartnerCommissionReports = function PartnerCommissionReports(_ref) {
  var match = _ref.match;

  var _useUser = useUser(),
      roleAdditionalData = _useUser.roleAdditionalData;

  var isPartnerOrPartnerManager = roleAdditionalData === null || roleAdditionalData === void 0 ? void 0 : roleAdditionalData.isPartnerOrPartnerManager;
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(ListHeader, {
    title: "\u041E\u0442\u0447\u0435\u0442\u0438 \u043A\u043E\u043C\u0438\u0441\u0438\u043E\u043D\u0438 \u0414\u041F"
  }), ___EmotionJSX(Tabs, {
    startingRoute: match.url,
    noAnimation: true
  }, isPartnerOrPartnerManager ? [___EmotionJSX(Tab, {
    key: "current",
    url: "/current",
    component: CurrentReportTab,
    label: "\u041E\u0442\u0447\u0435\u0442"
  }), ___EmotionJSX(Tab, {
    key: "all-history",
    url: "/all-history",
    component: AllPastReportsTab,
    label: "\u041C\u0438\u043D\u0430\u043B\u0438 \u043E\u0442\u0447\u0435\u0442\u0438"
  })] : [___EmotionJSX(Tab, {
    key: "all-history",
    url: "/all-history",
    component: AllPastReportsTab,
    label: "\u041C\u0438\u043D\u0430\u043B\u0438 \u043E\u0442\u0447\u0435\u0442\u0438"
  })]));
};

PartnerCommissionReports.propTypes = {
  match: PropTypes.object
};
export default PartnerCommissionReports;